import React, { Component } from "react";
import { PageHeader, ListGroup, ListGroupItem } from "react-bootstrap";
import { API } from "aws-amplify";
import "./Events.css";


export default class Events extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      events: [],
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
  
    try {
      const events = await this.events();
      this.setState({ events });

    } catch (e) {
      alert(e);
    }
  
    this.setState({ isLoading: false });
  }
  
  events() {
    return API.get("contacts", "/events");
  }

  renderEventsList(events) {
    return [{}].concat(events).map( // TODO ----
      (event, i) =>
        i !== 0
          ? <ListGroupItem
              key={event._source.exaId}
              href={`/timeline/${event._source.contactIdFrom}`}
              onClick={this.handleItemClick}
              header={event._source.eventSubject}
            >
              {"from: " + event._source.eventFrom}
              <br></br>
              {"received: " + new Date(event._source.appTimestamp).toLocaleString()}
            </ListGroupItem>
          : <ListGroupItem
              key="new"
              href="/notes/new"
              onClick={this.handleItemClick}
            >
              <h4>
                <b>{"\uFF0B"}</b> Create a new timeline items
              </h4>
            </ListGroupItem>
    );
  }
  
  handleItemClick = event => { // TODO --- LATER
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute("href"));
  }

  
  

  renderEvents() {
    return (
      <div className="events">
        <PageHeader>Your Events</PageHeader>
        <ListGroup>
          {!this.state.isLoading && this.renderEventsList(this.state.events)}
        </ListGroup>
      </div>
    );
  }

  render() { // instead, redirect to Home
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderEvents() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Events.js